import { Box, Container, Grid, Typography, useMediaQuery } from '@mui/material';
import gaiaTheme from '../../../../root-components/theme';
import { ReportingSecrForm } from '../../../presentation-components/reporting-components/secr/reporting-secr-form';
import { IGeneratedSecrReportResponse, IReportSECRGenerate } from '../../../../shared/services/generated-report/generated-report.model';
import GeneratedReportService from '../../../../shared/services/generated-report/generatedReport.service';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';
import { ReportPeriodContext } from '../../../../context/report-periods/report-periods';

export const ReportingSecrFormPage = () => {

  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const generatedReportService = new GeneratedReportService()
  const [report, setReport] = useState<IGeneratedSecrReportResponse>()
  const userNotificationsContext = useContext(UserNotificationsContext)
  const [hasExistingReport, setHasExistingReport] = useState<boolean>(false)
  const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false)
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  const reportPeriodContext = useContext(ReportPeriodContext);
  const [reportPeriodName, setReportPeriodName] = useState<string>('');


  useEffect(() => {
    if (searchParams.has('secrId')) {
      const token = searchParams.get('secrId')
      if (token) {
        generatedReportService.getReport(token)
          .then(response => {
            if (response) {
              setHasExistingReport(true)
              setReport(response);
              if (response.reportDetails && response.reportDetails.length > 0) {
                setReportPeriodName(response.reportDetails[0].reportPeriodName);
              }
            }
          })
          .catch(err => console.log(err))
      }
    }
  }, [])

  useEffect(() => {
    if (searchParams.has('reportPeriodId')) {
      const token = searchParams.get('reportPeriodId');
      if (token && reportPeriodContext.allReportPeriods) {
        const foundReportPeriod = reportPeriodContext.allReportPeriods.find(reportPeriod => reportPeriod.id === token);
        if (foundReportPeriod) {
          setReportPeriodName(foundReportPeriod.friendlyName);
        }
      }
    }
  }, [searchParams, reportPeriodContext.allReportPeriods]);

  const generateReport = (values: IReportSECRGenerate) => {
    if (!isFormSubmitting) {
      setIsFormSubmitting(true)
      generatedReportService.createGeneratedReport(values)
        .then(response => {
          navigate(`/reporting/secr/${response.id}`)
          setIsFormSubmitting(false)
        })
        .catch(err => {
          userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          setIsFormSubmitting(false)
          console.log(err)
        })
    }

  }

  return (
    <PageOuterContainer>
      <PageHeading
        title='Streamlined Energy and Carbon Reporting (SECR)'
        includeBackButton={true}
        backButtonLink={hasExistingReport && report ? `/reporting/secr/${report.id}` : '/reporting/secr'}
        backButtonText={hasExistingReport ? 'Back to report' : 'Back to SECR reports'}
      />
      <Grid container spacing={2}>
        {!hasExistingReport && <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Container
            maxWidth='lg'
          >
            <Box sx={{ borderWidth: '1px', borderStyle: 'solid', borderColor: 'lightGrey.main', borderRadius: '10px', p: isMobileMode ? 2 : 6 }}>
              <Typography variant='subtitle1' sx={{ color: 'text.primary', mb: 2 }}>
                {`Create Streamlined Energy and Carbon Reporting (SECR) Form${reportPeriodName ? ` for ${reportPeriodName}` : ''}`}
              </Typography>
              <ReportingSecrForm
                isSubmitting={isFormSubmitting}
                submitHandler={generateReport} />
            </Box>
          </Container>
        </Grid>}
        {hasExistingReport && report && <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Container
            maxWidth='lg'>
            <Box sx={{ borderWidth: '1px', borderStyle: 'solid', borderColor: 'lightGrey.main', borderRadius: '10px', p: isMobileMode ? 2 : 6 }}>
              <Typography variant='subtitle1' sx={{ color: 'text.primary', mb: 2 }}>
                {`Edit Streamlined Energy and Carbon Reporting (SECR) Form${reportPeriodName ? ` for ${reportPeriodName}` : ''}`}
              </Typography>
              <ReportingSecrForm
                isSubmitting={isFormSubmitting}
                submitHandler={generateReport}
                isEditPage={true}
                report={report} />
            </Box>
          </Container>
        </Grid>}
      </Grid>
    </PageOuterContainer>)
}